import React, { ReactNode } from 'react';

import { useQuery } from '@apollo/client/react';

import { RoleScope } from '../graphql/__generated__/schema';
import { ViewerDocument } from '../graphql/__generated__/types';
import Rail from './Rail';

interface Props {
    children: ReactNode;
}

/**
 * Rail plus content. The `viewer` query is re-declared rather than threaded down
 * from `BackofficeGuard`: Apollo serves it from the cache, same query, same
 * variables, so this costs no request, and the rail stays readable on its own.
 */
const Layout = ({ children }: Props) => {
    const { data } = useQuery(ViewerDocument);

    const viewer = data?.viewer;
    const memberships = viewer?.memberships ?? [];
    // The internal membership, the one the guard checked. A staff member has exactly
    // one, on Freelance.com.
    const staff = memberships.find((membership) => membership?.role?.scope === RoleScope.Backoffice);

    const name = [viewer?.firstName, viewer?.lastName].filter(Boolean).join(' ') || (viewer?.email ?? '');

    return (
        <div className="flex min-h-screen">
            <Rail name={name} roleName={staff?.role?.name ?? ''} />
            {/* Content spans the full width (the mockup's 1180px column is dropped); the
                margins stay. */}
            <main className="min-w-0 flex-1">
                <div className="px-7 pb-16 pt-6">{children}</div>
            </main>
        </div>
    );
};

export default Layout;
